import dayjs from '~/timeInit';

import type { ProjectTaskStatus } from '~/services/ContractingService';

export const PROJECT_TASK_STATUSES: ReadonlyArray<ProjectTaskStatus> = [
  'NOT_STARTED',
  'IN_PROGRESS',
  'COMPLETED',
  'ON_HOLD',
  'CANCELLED',
];

export const TASK_STATUS_LABELS: Record<ProjectTaskStatus, string> = {
  NOT_STARTED: 'Not Started',
  IN_PROGRESS: 'In Progress',
  COMPLETED: 'Completed',
  ON_HOLD: 'On Hold',
  CANCELLED: 'Cancelled',
};

export function formatProjectDate(date: string) {
  return dayjs(date).format('D/M/YY');
}
